import sun from "./../../img/icons/sun.svg"
import { useLocalStorage } from "../../utils/useLocalStorage";
import moon from "./../../img/icons/moon.svg"
import "./style.css";
import { useEffect, useRef } from "react";
import detectDarkMode from "../../utils/detectDarkMode";

const BtnDarkMoude = () => {
    const [darkMoude, setDarkMoude] = useLocalStorage('darkMoude', detectDarkMode());

    const btnRef =  useRef(null)

    useEffect(() => {
        if(darkMoude === 'dark') {
            document.body.classList.add('dark');
            btnRef.current.classList.add('dark-mode-btn--active')
        } else {
            document.body.classList.remove('dark');
            btnRef.current.classList.remove('dark-mode-btn--active')
        }
    },[darkMoude])


    const toggelDarkMode = () => {
        setDarkMoude((currentValue) => {
            return currentValue === 'ligth' ? 'dark' : 'ligth';
        });
    }

    return (
        <button ref={btnRef} onClick={toggelDarkMode} className="dark-mode-btn">
            <img src={sun} alt="Light mode" className="dark-mode-btn__icon" />
            <img src={moon} alt="Dark mode" className="dark-mode-btn__icon" />
        </button>
    )
}

export default BtnDarkMoude;